import React, { useEffect, useState } from 'react';
import { Button, Popup, SelectBox, TextBox } from 'devextreme-react';
import './CountertopProfileSelectionPopup.scss';
import { useGetCountertopProfiles } from '../api/get-countertop-profiles';
import { useCreateCountertopUniversityProfile } from '../api/create-countertop-university-profile';
import { showErrorMessage, showSuccessMessage } from '../../../../utils/messages';
import { useAuth } from '../../../../contexts/auth';
import { useCountertopUniversity } from '../contexts/countertopUniversityContext';

const CountertopProfileSelectionPopup = () => {
    const context = useCountertopUniversity();
    const [selectedProfile, setSelectedProfile] = useState<string | null>(null);
	const { user } = useAuth();
    const [fullName, setFullName] = useState<string>('');
    const { data: profiles, refetch: refetchProfiles, isRefetching: isFilesRefetching } = useGetCountertopProfiles(user?.companyId);

    const createProfile = useCreateCountertopUniversityProfile(
        fullName,
        async (profileID) => {
          showSuccessMessage('Profile created!');
          await refetchProfiles();
          context.setProfileFullName(fullName.trim());
          context.setProfileID(profileID);
          setFullName('');
          closeModal();
        },
        (error) => {
          showErrorMessage(error);
        }
      );
      
    const handleProfileChange = (e: any) => {
        setSelectedProfile(e.value);
    };

    const handleFullNameChange = (e: any) => {
        setFullName(e.value);
    };

    const closeModal = (() => {
        let isClosed = false; // Prevent duplicate calls
        return (value: string | null = null) => {
            if (isClosed) return;
            isClosed = true;
            context.setProfilePopupVisible(false);
        };
    })();

    const handleContinue = async () => {
        if (fullName.trim()) {
            setFullName(fullName.trim());
            
            await createProfile.mutate();
        } else if (selectedProfile) {
            const selectedProfileDisplayValue = profiles?.find(profile => profile.profileID === Number(selectedProfile))?.profileName || '';
            context.setProfileID(Number(selectedProfile));
            context.setProfileFullName(selectedProfileDisplayValue);
            context.onDataRefresh?.();
            closeModal();
        } else {
            showErrorMessage('Please select a profile or enter a full name.');
        }
    };

    return (
        <>
            <Popup
                visible={context.profilePopupVisible}
                title="Select a profile"
                width={800}
                height={425}
                onHiding={() => closeModal(null)}
            >
                <div>
                    <p className="header-info">Please select your name or create a new profile</p>
                    <div>
                        <div className="label-control-info">Profile</div>
                        <div>
                            <SelectBox
                                displayExpr="profileName"
                                dataSource={profiles}
                                searchEnabled={true}
                                valueExpr="profileID"
                                value={selectedProfile}
                                showClearButton={true}
                                placeholder="Select profile"
                                onValueChanged={handleProfileChange} />
                        </div>
                    </div>

                    <div className="separator-container">
                        <hr className="separator-line" />
                        <span className="separator-text">or, create a new profile</span>
                    </div>

                    <div>
                        <div className="label-control-info">Full Name</div>
                        <div>
                            <TextBox
                                placeholder="Enter Full Name"
                                value={fullName}
                                onValueChanged={(e) => {
                                    handleFullNameChange(e);
                                    setSelectedProfile(null); // Unselect profile during typing in the TextBox
                                }}
                                
                                />
                        </div>
                    </div>

                    <div className="button-container">
                        <Button
                            text={createProfile.isLoading ? 'Creating...' : 'Continue Academy'}
                            type="default"
                            onClick={handleContinue}
                            disabled={createProfile.isLoading} />
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default CountertopProfileSelectionPopup;